import { render } from "./dubai.vue?vue&type=template&id=326a1874&scoped=true"
import script from "./dubai.vue?vue&type=script&lang=js"
export * from "./dubai.vue?vue&type=script&lang=js"

import "./dubai.vue?vue&type=style&index=0&id=326a1874&lang=scss&scoped=true"
import "./dubai.vue?vue&type=style&index=1&id=326a1874&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-326a1874"

export default script